import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { textStyle } from '../theme';
import PnmacText from '../../Typography/PnmacText';
function BannerView(_a) {
  var style = _a.style,
    children = _a.children,
    _b = _a.type,
    type = _b === void 0 ? 'default' : _b;
  var bannerStyle = useMemo(function () {
    var s;
    switch (type) {
      case 'success':
        {
          s = textStyle.bannerViewSuccess;
          break;
        }
      case "warning":
        {
          s = textStyle.bannerViewWarning;
          break;
        }
      case "error":
        {
          s = textStyle.bannerViewError;
          break;
        }
      default:
        {
          s = textStyle.notificationBox;
        }
    }
    return s;
  }, [type]);
  return /*#__PURE__*/React.createElement(View, {
    accessible: true,
    accessibilityLabel: 'Banner',
    style: [styles.view, bannerStyle, style]
  }, children);
}
BannerView.Text = function BannerViewText(props) {
  return /*#__PURE__*/React.createElement(PnmacText, __assign({}, props, {
    style: textStyle.notificationText,
    nativeID: props.idTag1
  }), props.children);
};
var styles = StyleSheet.create({
  view: {
    padding: 10,
    marginTop: 0,
    borderRadius: 10,
    borderWidth: 1
  }
});
export default BannerView;